import { ReactNode } from 'react';

export enum Route {
  ADMIN = '/admin',
  ADMIN_INTEGRATIONS = '/admin/integrations',
  ADMIN_TENANT = '/admin/org',
  ADMIN_ROLES = '/admin/roles',
  ADMIN_USERS = '/admin/users',
  ADMIN_MACHINES = '/admin/machines',
  ADMIN_TEAMS = '/admin/teams',
  ADMIN_EXPORT = '/admin/export',
  APP_MODE = '/app-mode',
  AUTH_SIGNUP = '/auth/signup',
  AUTH_LOGIN = '/auth/login',
  AUTH_LOGOUT = '/auth/logout',
  AUTH_CONFIRM = '/auth/confirm',
  AUTH_CONFIRM_PASSWORD = '/auth/password-confirm',
  BILLING = '/billing',
  DIRECT_CONNECT = '/direct',
  HOME = '/home',
  NEW_TEAM = '/teams/new',
  NOTIFICATIONS = '/notifications',
  MACHINES = '/machines',
  TEAMS = '/teams',
  USER = `/user`,
}
export interface RouteBuilderOptions {
  prefix?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  queryParams?: Record<string, any> | string;
}

export interface RouteBuilder {
  getAdminEventIntegrationsRoute(options?: RouteBuilderOptions): string;
  getAdminRoute(options?: RouteBuilderOptions): string;
  getAdminRoleRoute(roleId: string, options?: RouteBuilderOptions): string;
  getAdminRolesRoute(options?: RouteBuilderOptions): string;
  getAdminTenantRoute(options?: RouteBuilderOptions): string;
  getAdminUsersRoute(options?: RouteBuilderOptions): string;
  getAdminUserRoute(userId: string, options?: RouteBuilderOptions): string;
  getAdminMachinesRoute(options?: RouteBuilderOptions): string;
  getAdminTeamsRoute(options?: RouteBuilderOptions): string;
  getAdminExportRoute(options?: RouteBuilderOptions): string;
  getAppModeSelectionRoute(): string;
  getAuthLoginRoute(): string;
  getAuthSignupRoute(): string;
  getAuthLogoutRoute(): string;
  getAuthConfirmRoute(): string;
  getAuthConfirmPasswordRoute(): string;
  getBillingRoute(options?: RouteBuilderOptions): string;
  getDirectConnectSelectMachineRoute(): string;
  getDirectConnectMachineRoute(machineId: string): string;
  getDirectConnectKioskRoute(): string;
  getHomeRoute(options?: RouteBuilderOptions): string;
  getMachineRoute(
    teamId: string,
    machineId: string,
    options?: RouteBuilderOptions
  ): string;
  getMachinesRoute(teamId: string, options?: RouteBuilderOptions): string;
  getMachineApplicationsRoute(
    teamId: string,
    machineId: string,
    options?: RouteBuilderOptions
  ): string;
  getMachineApplicationRoute(
    teamId: string,
    machineId: string,
    applicationId: string,
    options?: RouteBuilderOptions
  ): string;
  getMachineDetailsRoute(
    teamId: string,
    machineId: string,
    options?: RouteBuilderOptions
  ): string;
  getMachineMaintenanceRoute(
    teamId: string,
    machineId: string,
    options?: RouteBuilderOptions
  ): string;
  getMachineEventDefinitionsRoute(
    teamId: string,
    machineId: string,
    options?: RouteBuilderOptions
  ): string;
  getMachineEventDefinitionRoute(
    teamId: string,
    machineId: string,
    eventDefinitionId: string,
    options?: RouteBuilderOptions
  ): string;
  getMachineFilesRoute(
    teamId: string,
    machineId: string,
    options?: RouteBuilderOptions
  ): string;
  getMachineFileRoute(
    teamId: string,
    machineId: string,
    fileId: string,
    options?: RouteBuilderOptions
  ): string;
  getMachineIORoute(
    teamId: string,
    machineId: string,
    options?: RouteBuilderOptions
  ): string;
  getMachineLogsRoute(
    teamId: string,
    machineId: string,
    options?: RouteBuilderOptions
  ): string;
  getMachineRealtimeRoute(
    teamId: string,
    machineId: string,
    options?: RouteBuilderOptions
  ): string;
  getMachineScratchpadRoute(
    teamId: string,
    machineId: string,
    scratchpadId: string,
    options?: RouteBuilderOptions
  ): string;
  getMachineVariablesRoute(
    teamId: string,
    machineId: string,
    options?: RouteBuilderOptions
  ): string;
  getNotificationsRoute(options?: RouteBuilderOptions): string;
  getNewTeamRoute(options?: RouteBuilderOptions): string;
  getTeamsRoute(options?: RouteBuilderOptions): string;
  getTeamRoute(teamId: string, options?: RouteBuilderOptions): string;
  getTeamChartRoute(
    teamId: string,
    chartId: string,
    options?: RouteBuilderOptions
  ): string;
  getTeamChartTemplatesRoute(
    teamId: string,
    options?: RouteBuilderOptions
  ): string;
  getTeamChatRoute(teamId: string, options?: RouteBuilderOptions): string;
  getTeamChatThreadRoute(
    teamId: string,
    threadId: string,
    options?: RouteBuilderOptions
  ): string;
  getTeamHomeRoute(teamId: string, options?: RouteBuilderOptions): string;
  getTeamMoreRoute(teamId: string, options?: RouteBuilderOptions): string;
  getTeamSetupRoute(teamId: string, options?: RouteBuilderOptions): string;
  getTeamUsersRoute(teamId: string, options?: RouteBuilderOptions): string;
  getUsersRoute(options?: RouteBuilderOptions): string;
  getUserRoute(userId: string, options?: RouteBuilderOptions): string;
  build(path: string, options?: RouteBuilderOptions): string;
}

export interface BeaconRouterContextValue {
  builder: RouteBuilder;
  navigateToLogout(): Promise<void>;
  performWindowNavigation(url: string): Promise<void>;
}

export type RouteBuilderFactory = () => RouteBuilder;

export interface BeaconRouterContextProviderProps {
  children: ReactNode;
  routeBuilderFactory?: RouteBuilderFactory;
}
